export const getArticlesFromLocalStorage = () => {
  const storedArticles = JSON.parse(localStorage.getItem("articles"));

  if (storedArticles) {
    return storedArticles;
  }
  return [];
};
